import {Chip} from "@mui/material";

export function StatusChip ({success}:{success:boolean}) {
    return (
        <Chip
            label={success ? "Sucesso" : "Falha"}
            size="small"
            sx={{
                height: 32,
                width: '82px',
                borderRadius: '100px',
                padding: '4px',
                bgcolor: success ? '#1BB483' : '#FC531F',
                color: '#FFFFFF',
                fontWeight: 500,
                lineHeight: '18px',
                fontSize: 13,
                letterSpacing: '0.16px',
                "& .MuiChip-label": {
                    px: 1.25,
                    py: 0,
                },
            }}
        />
    );
}